/**
 * EcrireBand — free-text textarea for the composer.
 *
 * Splits on newlines into draft lines. « Vérifier » button → calls bulk
 * dryRun in chunks of 100, then opens ReviewTable.
 *
 * @see B-popup-frontend.md step 5, Files and props § EcrireBand
 */
import { Box, TextField } from '@mui/material';
import { draftLines, overCapLines } from './composerModel';

export interface EcrireBandProps {
  draft: string;
  onChange: (draft: string) => void;
}

export function EcrireBand({ draft, onChange }: EcrireBandProps) {
  const lines = draftLines(draft);
  const capCount = overCapLines(lines);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, px: 0.5 }}>
      <TextField
        multiline
        fullWidth
        value={draft}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Une question par ligne" // i18n: promptStudio.draft.placeholder
        minRows={4}
        maxRows={12}
        sx={{
          '& .MuiInputBase-root': { fontSize: 13, fontFamily: 'inherit' },
          '& textarea': { resize: 'vertical' },
        }}
        inputProps={{ 'data-ps-control': 'ecrire-draft' }}
      />
      {capCount > 0 && (
        <Box sx={{ mt: 0.75, fontSize: 12, color: '#b45309' }}>
          {/* i18n: promptStudio.draft.overCap */}
          {capCount} ligne{capCount > 1 ? 's dépassent' : ' dépasse'} 300 caractères
        </Box>
      )}
      <Box sx={{ mt: 0.5, fontSize: 12, color: 'text.disabled' }}>
        {/* i18n: promptStudio.draft.lineCount */}
        {lines.length} question{lines.length !== 1 ? 's' : ''}
      </Box>
    </Box>
  );
}
